import { httpClient } from './utils'
import { actions } from './redux-oauth2'
import Url from './config'
import {envValue} from '../config/envUtils';

const FRONTMAN_URL = envValue('FRONTMAN_URL');
const AUTH_TOKEN =  envValue("AUTH_TOKEN");

import { ACCESS_POINTS } from '../src/constants/AccessPoints';

/**
 * Legacy functions
 */

const userHasAccessToRequest = (accessId) => {
    const arrayOfAccess = [
        ACCESS_POINTS.LABELS_VIEW,
        ACCESS_POINTS.LABELS_EDIT,
        ACCESS_POINTS.THEMES_VIEW,
        ACCESS_POINTS.THEMES_EDIT,
        ACCESS_POINTS.CONFIGURATION_VIEW,
        ACCESS_POINTS.CONFIGURATION_EDIT,
        ACCESS_POINTS.TRACKINGHOOKS_VIEW,
        ACCESS_POINTS.TRACKINGHOOKS_EDIT,
        ACCESS_POINTS.CUSTOMCONTENT_VIEW,
        ACCESS_POINTS.CUSTOMCONTENT_EDIT
    ]

    return arrayOfAccess.includes(accessId);
}

const get_token = (creds, cb) => {
    let combinedResponseData = {}
    const u = btoa(creds.user);
    const p = btoa(creds.password);
    const credential = btoa(`${u}:${p}`);
    httpClient.defaults.headers.common['Authorization'] = 'Basic ' + credential;
    return dispatch => {
        dispatch(actions.start());
        let currentTokenUrl
        let currentHotelListUrl
        if (window.location.hostname == '10.28.178.71') {
            currentTokenUrl = Url.authenticationUrl2
            currentHotelListUrl = Url.hotelListUrl2
        }
        else {
            currentTokenUrl = Url.authenticationUrl
            currentHotelListUrl = Url.hotelListUrl
        }

        httpClient.post(`${AUTH_TOKEN}/shs-security-services/v1/auth/token`, {
            "UserIPAddress": "123.123.123.123",
            "GrantType": "CLIENT_CREDENTIALS",
            "BusinessContext": "BE",
            "UserType": "Hotel"
        })
            .then((res) => {
                if (res.data.Errors && res.data.Errors.length > 0) {
                    const error = {
                        message: res.data.Errors[0].Message
                    }
                    cb({error: error});
                    dispatch(actions.error(error));
                }
                else {
                    dispatch(actions.username(res.data.ApplicationResult.Username))
                    combinedResponseData = res;
                    httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.access_token;
                    return httpClient.get(`${FRONTMAN_URL}/access/token/acl`).then(
                        (response) => {
                            const {accessPoints} = response.data.accessPoints
                            const allowAccess = accessPoints.find((elem) => {
                                return userHasAccessToRequest(elem.id);
                            })
                            if(allowAccess) {
                                return httpClient.post(`${AUTH_TOKEN}/shs-security-services/v1/auth/token/hotellist`, {
                                    "BookingSource": {
                                        "Channel": "CRS",
                                        "PrimaryChannel": "BookingEngine",
                                        "SecondaryChannel": "VoiceAgent",
                                        "SubSourceCode": "BE"
                                    },
                                    "Paging": {
                                        "Size": "1000",
                                        "Start": "1",
                                        "Total": "1000"
                                    },
                                    "Chain": {
                                        "Id": creds.chainId
                                    },
                                    "Destination": {
                                        "Id": "Dest-1",
                                        "Name": "Test Destination"
                                    }
                                }).then(hotelListResponse => {
                                    combinedResponseData.data['initialState'] = {
                                        hotellist: hotelListResponse.data.ApplicationResults.HotelList.hotel
                                    }
                                    dispatch(actions.defaultHotel(_.get(res, 'data.ApplicationResult.AccessObject.DefaultHotel')))
                                    dispatch(actions.complete(combinedResponseData.data, () => {
                                        // cb(null, res.data);
                                        cb({data: combinedResponseData.data});
                                    }));
                                })
                                .catch((e) => {
                                    cb({error: e});
                                    dispatch(actions.error(e));
                                })
                            }
                            else {
                                const e = {
                                    message:"The user is not authorized to log into the Booking Engine Designer UI"
                            }
                                cb({error: e});
                                dispatch(actions.error(e))
                            }
                        }
                    )
                    .catch((e) => {
                        cb({error: e});
                        dispatch(actions.error(e));
                    })

                }
            })
            .catch((e) => {
                console.log('error', e);
                cb({error: e});
                dispatch(actions.error(e));
            });
    };
}

export { get_token, userHasAccessToRequest };



// WEBPACK FOOTER //
// ./lib/legacy.js